const { default: Typography } = require('components/shared/Typography/Typography');
const { mString } = require('lib/helpers/utility');

const SummaryItem = ({ label, value, color = 'neutral-600' }) => {
  return (
    <div className="flex w-full items-center justify-between pl-2">
      <Typography variant="label" size="medium" weight="medium" color={color}>
        {label}
      </Typography>
      <Typography variant="label" size="medium">
        {mString(value)}
      </Typography>
    </div>
  );
};

export default SummaryItem;
